import React, { useState } from "react";
import { connect } from "react-redux";
import { CallbackComponent } from "redux-oidc";
import getUserManager from "../user-manager";
import { Navigate } from "react-router-dom";
import { Localized } from "../../components";
import { Spinner } from "../../components//state-indicators";
const CallbackPage = props => {
    const [redirectUrl, setURL] = useState(undefined);
    const userManager = getUserManager();
    return (
        <CallbackComponent
            userManager={userManager}
            successCallback={user => {
                setURL(user?.state?.redirectUrl);
            }}
            errorCallback={error => {
                console.error(error);
                setURL(undefined);

                // Почему-то вылетает здесь ошибка, но потом усмпешный колбек
                // setURL("/");
            }}>
            {redirectUrl !== undefined ? (
                <div>
                    <Navigate to={redirectUrl} />
                </div>
            ) : (
                <div style={{ position: "relative", height: "100vh", width: "100vw" }}>
                    <Localized>
                        <Spinner withCaption fillParent={true} />
                    </Localized>
                </div>
            )}
        </CallbackComponent>
    );
};

export default connect()(CallbackPage);
